import { render, staticRenderFns } from "./HistorialBandejasPorPacienteComponente.vue?vue&type=template&id=4fa47ef6"
import script from "./HistorialBandejasPorPacienteComponente.vue?vue&type=script&lang=js"
export * from "./HistorialBandejasPorPacienteComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports